const isUAT = process.env.NEXT_PUBLIC_APP_ENV === 'uat'
const stapleHours = [
  {
    days: 'Monday - Friday',
    hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
  },
]

const staplesHolidayMessage = null

export const activeLocations = {
  ...(isUAT && {
    SP101: {
      uid: 'SP101',
      address: '117 West 7th Austin, TX 78701',
      name: 'Staples - Austin HQ',
      parking:
        'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
      type: 'staples',
      hours: '9:00am - 5:00pm',
      serviceTerritoryId: '0Hhcn0000001embCAA',
      coordinates: {
        lat: 30.2692,
        lng: -97.7434,
      },
      city_and_state: 'Austin, TX',
      city: {
        document: {
          data: {
            name: 'Austin',
            state: 'TX',
          },
        },
      },
      lanes: [
        {
          id: 1,
          description:
            'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
          isAccessible: true,
          holidayMessage: staplesHolidayMessage,
          availability: [...stapleHours],
        },
      ],
    },
  }),
  EWR: {
    uid: 'ewr',
    id: '22baa3cc-29b7-5c82-9ae4-2ae2cef86f72',
    address: '3 Brewster Rd Newark, NJ 07114',
    name: 'Newark International Airport - EWR',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000azZCAQ' }),
    open: true,
    coordinates: {
      lat: 40.6933707748659,
      lng: -74.18283252766588,
    },
    city_and_state: 'Newark, NJ',
    city: {
      document: {
        data: {
          name: 'Newark',
          state: 'NJ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal A',
        description:
          'Located to the right of the security checkpoint entrance. Look for TSA PreCheck® and CLEAR pods.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 8:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal C',
        description:
          'Located on Level 3, Door 2 overlooking the TSA PreCheck® security checkpoint. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  MCO: {
    uid: 'mco',
    id: '66ecbc89-7961-5c3e-b62d-155bdcfdf58b',
    address: '1 Jeff Fuqua Blvd Orlando, FL 32827',
    name: 'Orlando International Airport - MCO',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '4:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000amfCAA' }),
    coordinates: {
      lat: 28.431157699999993,
      lng: -81.30808300000001,
    },
    city_and_state: 'Orlando, FL',
    city: {
      document: {
        __typename: 'PrismicCity',
        data: {
          name: 'Orlando',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminals A & B',
        description:
          'Located on the B side (west side) of the security checkpoint entrance for Gates 1-59, next to the United Airlines ticket counter. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 8:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal C',
        description:
          'Located in front of the security checkpoint entrance for Gates 230-249. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  SMF: {
    uid: 'smf',
    address: '6900 Airport Blvd Sacramento, CA 95837',
    name: 'Sacramento International Airport - SMF',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bSbCAI' }),
    coordinates: {
      lat: 38.6955,
      lng: -121.59083,
    },
    city_and_state: 'Sacramento, CA',
    city: {
      document: {
        data: {
          name: 'Sacramento',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal A',
        description:
          'Located in front of the security checkpoint entrance on Level 2. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '12:00pm - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal B',
        description:
          'Located on the right side of the AirTrain entrance. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '12:00pm - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  LGA: {
    uid: 'lga',
    address: '9400 Ditmars Blvd East Elmhurst, NY 11369',
    name: 'LaGuardia Airport - LGA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bNlCAI' }),
    open: true,
    coordinates: {
      lat: 40.776863,
      lng: -73.874069,
    },
    city_and_state: 'New York City, NY',
    city: {
      document: {
        data: {
          name: 'New York City',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 2,
        name: 'Terminal B',
        description:
          'Located on Level 2 - Arrivals, between Baggage Claim 4 and 5 near the elevators. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
      {
        id: 1,
        name: 'Terminal C',
        description:
          'Located in front of the security checkpoint entrance on Level 3. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '5:00am - 6:00pm',
          },
        ],
      },
      {
        id: 3,
        name: 'Terminal C, Post-Security Checkpoint',
        description:
          'Located right after the security checkpoint on the standard screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  SLC: {
    uid: 'slc',
    address: '3920 W. Terminal Dr Salt Lake City, UT 84122',
    name: 'Salt Lake City International Airport - SLC',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bArCAI' }),
    open: true,
    coordinates: {
      lat: 40.7863,
      lng: -111.9733,
    },
    city_and_state: 'Salt Lake City, UT',
    city: {
      document: {
        data: {
          name: 'Salt Lake City',
          state: 'UT',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the left side of the main security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  SEA: {
    uid: 'sea',
    address: '17801 International Blvd SeaTac, WA 98158',
    name: 'Seattle-Tacoma International Airport - SEA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bE5CAI' }),
    open: true,
    coordinates: {
      lat: 47.443546,
      lng: -122.301659,
    },
    city_and_state: 'Seattle, WA',
    city: {
      document: {
        data: {
          name: 'Seattle',
          state: 'WA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located at Checkpoint 3 near the Delta Air Lines ticket counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  LAS: {
    uid: 'las',
    address: '5757 Wayne Newton Blvd Las Vegas, NV 89119',
    name: 'Harry Reid International Airport - LAS',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bIvCAI' }),
    coordinates: {
      lat: 36.083134,
      lng: -115.148315,
    },
    city_and_state: 'Las Vegas, NV',
    city: {
      document: {
        data: {
          name: 'Las Vegas',
          state: 'NV',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 1',
        description:
          'Located on the second floor near the security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  BHM: {
    uid: 'bhm',
    address: '5900 Messer Airport Hwy Birmingham, AL 35212',
    name: 'Birmingham-Shuttlesworth International Airport - BHM',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WpVCAU' }),
    coordinates: {
      lat: 33.5625,
      lng: -86.7542,
    },
    city_and_state: 'Birmingham, AL',
    city: {
      document: {
        data: {
          name: 'Birmingham',
          state: 'AL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located in front of the security checkpoint on the Departure level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '7:00am - 6:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 4:00pm',
          },
        ],
      },
    ],
  },
  LAX: {
    uid: 'lax',
    address: '1 World Way Los Angeles, CA 90045',
    name: 'Los Angeles International Airport - LAX',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bKXCAY' }),
    coordinates: {
      lat: 33.942791,
      lng: -118.410042,
    },
    city_and_state: 'Los Angeles, CA',
    city: {
      document: {
        data: {
          name: 'Los Angeles',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 3, West - TSA PreCheck Screening Side',
        description:
          'Located on the third floor in Delta Terminal near the TSA PreCheck screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal 7',
        accessibilityMessage:
          'Accessible pods are available at Terminal 3 East - Standard Screening Side and Terminal 3 West - TSA PreCheck Screening Side',
        description:
          'Located on Level 2 Departures, across from the security screening area. Look for TSA PreCheck and CLEAR signage.',
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  SAN: {
    uid: 'san',
    address: '3225 N Harbor Dr San Diego, CA 92101',
    name: 'San Diego International Airport - SAN',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '5:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WfpCAE' }),
    coordinates: {
      lat: 32.73177,
      lng: -117.197624,
    },
    city_and_state: 'San Diego, CA',
    city: {
      document: {
        data: {
          name: 'San Diego',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 2',
        description:
          'Located to the left of the entrance on the second floor of Terminal 2. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '5:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  MKE: {
    uid: 'mke',
    address: '5300 S Howell Ave Milwaukee, WI 53207',
    name: 'Milwaukee Mitchell International Airport - MKE',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000Zx3CAE' }),
    coordinates: {
      lat: 42.94989,
      lng: -87.900414,
    },
    city_and_state: 'Milwaukee, WI',
    city: {
      document: {
        data: {
          name: 'Milwaukee',
          state: 'WI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on Concourse C and Concourse D nearby the security checkpoint on the Departured level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Thursday',
            hours: '6:00am - 6:00pm',
          },
          {
            days: 'Friday - Saturday',
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  DCA: {
    uid: 'dca',
    address: '2401 Smith Boulevard Arlington, VA 22202',
    name: 'Ronald Reagan Washington National Airport - DCA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 9:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ahpCAA' }),
    coordinates: {
      lat: 38.8512,
      lng: -77.0402,
    },
    city_and_state: 'Arlington, VA',
    city: {
      document: {
        data: {
          name: 'Arlington',
          state: 'VA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 2',
        description:
          'Located near the main security checkpoint next to American Airlines ticketing counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 9:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  JFK: {
    uid: 'jfk',
    address: 'JFK Access Rd New York, NY 11430',
    name: 'John F. Kennedy International Airport - JFK',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '5:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ajRCAQ' }),
    coordinates: {
      lat: 40.641766,
      lng: -73.780968,
    },
    city_and_state: 'New York, NY',
    city: {
      document: {
        data: {
          name: 'New York',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 4',
        description:
          'Located to the right of the security checkpoint, near Row #1 at Delta Priority Check-In on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '5:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  HOU: {
    uid: 'hou',
    address: '7800 Airport Blvd Houston, TX 77061',
    name: 'William P. Hobby Airport - HOU',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ZvRCAU' }),
    coordinates: {
      lat: 29.6459,
      lng: -95.2769,
    },
    city_and_state: 'Houston, TX',
    city: {
      document: {
        data: {
          name: 'Houston',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located in front of the main security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Monday, Wednesday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Tuesday',
            hours: '6:00am - 7:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  IAH: {
    uid: 'iah',
    address: '2800 N Terminal Rd Houston, TX 77032',
    name: 'George Bush Intercontinental Airport - IAH',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '4:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000b9FCAQ' }),
    coordinates: {
      lat: 29.9931,
      lng: -95.3416,
    },
    city_and_state: 'Houston, TX',
    city: {
      document: {
        data: {
          name: 'Houston',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal A',
        description:
          'Located on Level 2 Departures between Southwest and Delta Air Lines check-in counters. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal A - South',
        availability: [
          {
            hours: '4:00am - 6:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal C',
        accessibilityMessage:
          'Accessible pod is available at Terminal A - South',
        description:
          'Located on Level 2 at the United Airlines checkpoint. Look for TSA PreCheck and CLEAR signage.',
        availability: [
          {
            hours: '6:00am - 7:00pm',
          },
        ],
      },
      {
        id: 3,
        name: 'Terminal C - Post Security',
        accessibilityMessage:
          'Accessible pod is available at Terminal A - South',
        description:
          'Located near the entrance to the Skyway. Look for TSA PreCheck and CLEAR signage.',
        availability: [
          {
            hours: '7:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  LGB: {
    uid: 'lgb',
    address: '4100 Donald Douglas Dr Long Beach, CA 90808',
    name: 'Long Beach Airport - LGB',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WvxCAE' }),
    coordinates: {
      lat: 33.8161,
      lng: -118.1513,
    },
    city_and_state: 'Long Beach, CA',
    city: {
      document: {
        data: {
          name: 'Long Beach',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located inside the Main Terminal on the TSA PreCheck screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  MSP: {
    uid: 'msp',
    address: '4300 Glumack Dr St Paul, MN 55111',
    name: 'Minneapolis-Saint Paul International Airport - MSP',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aRhCAI' }),
    coordinates: {
      lat: 44.8851,
      lng: -93.2144,
    },
    city_and_state: 'St Paul, MN',
    city: {
      document: {
        data: {
          name: 'St Paul',
          state: 'MN',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 1',
        description:
          'Located on the left hand side of Door 1, across from the American Airlines ticketing counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  MSY: {
    uid: 'msy',
    address: '900 Airline Dr Kenner, LA 70062',
    name: 'Louis Armstrong New Orleans International Airport - MSY',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '4:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000b1BCAQ' }),
    coordinates: {
      lat: 29.9937,
      lng: -90.2619,
    },
    city_and_state: 'Kenner, LA',
    city: {
      document: {
        data: {
          name: 'Kenner',
          state: 'LA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the second floor on the right side of the security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  SFO: {
    uid: 'sfo',
    name: 'San Francisco International Airport - SFO',
    address: 'SFO Airport San Francisco, CA 94128',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000YphCAE' }),
    coordinates: {
      lat: 37.615223,
      lng: -122.389977,
    },
    city_and_state: 'San Francisco, CA',
    city: {
      document: {
        data: {
          name: 'San Francisco',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 2',
        accessibilityMessage:
          'Accessible pod is available at Terminal 3 - T3F1',
        description:
          'Located near Door 5 on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal 3',
        description:
          'Located across from the United Airlines Global check-in on the far right of the checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: 3,
        name: 'International Terminal A',
        accessibilityMessage:
          'Accessible pod is available at Terminal 3 - T3F1',
        description:
          'Located in front of the security checkpoint on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        availability: [
          {
            hours: '7:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  PVD: {
    uid: 'pvd',
    address: '2000 Post Rd. Warwick, RI 02886',
    name: 'Rhode Island T.F. Green International Airport - PVD',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WntCAE' }),
    coordinates: {
      lat: 41.7217,
      lng: -71.4295,
    },
    city_and_state: 'Warwick, RI',
    city: {
      document: {
        data: {
          name: 'Warwick',
          state: 'RI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the Departures level (Level 2) in front of the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  ATL: {
    uid: 'atl',
    address: '6000 N Terminal Pkwy Atlanta, GA 30320',
    name: 'Hartsfield-Jackson Atlanta International Airport - ATL',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WcbCAE' }),
    coordinates: {
      lat: 33.640411,
      lng: -84.419853,
    },
    city_and_state: 'Atlanta, GA',
    city: {
      document: {
        data: {
          name: 'Atlanta',
          state: 'GA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the North side on the Departure level, near the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Main Terminal - South',
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'International Terminal',
        description:
          'Located inside of the door D1 on the Departure level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  AUS: {
    uid: 'aus',
    address: '3600 Presidential Blvd Austin, TX 78719',
    name: 'Austin-Bergstrom International Airport - AUS',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 5:30pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bVpCAI' }),
    coordinates: {
      lat: 30.1953,
      lng: -97.6667,
    },
    city_and_state: 'Austin, TX',
    city: {
      document: {
        data: {
          name: 'Austin',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located in Checkpoint 1 to the left of the TSA PreCheck line. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  DEN: {
    uid: 'den',
    address: '8500 Pena Blvd Denver, CO 80249',
    name: 'Denver International Airport - DEN',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '5:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bCTCAY' }),
    coordinates: {
      lat: 39.849312,
      lng: -104.673828,
    },
    city_and_state: 'Denver, CO',
    city: {
      document: {
        data: {
          name: 'Denver',
          state: 'CO',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal, South',
        description:
          'Located on the southwest corner of the security checkpoint, under the escalator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  DTW: {
    uid: 'dtw',
    address: '1 Detroit Metro Airport Romulus, MI 48242',
    name: 'Detroit Metropolitan Wayne County Airport - DTW',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WeDCAU' }),
    coordinates: {
      lat: 42.2132,
      lng: -83.3525,
    },
    city_and_state: 'Romulus, MI',
    city: {
      document: {
        data: {
          name: 'Romulus',
          state: 'MI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'McNamara Terminal, Red 1',
        description:
          'Located near Door 4 on the Departures level of the McNamara security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  IAD: {
    uid: 'iad',
    address: '1 Saarinen Cir Dulles, VA 20166',
    name: 'Washington Dulles International Airport - IAD',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 9:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a0HCAQ' }),
    coordinates: {
      lat: 38.9523,
      lng: -77.4586,
    },
    city_and_state: 'Dulles, VA',
    city: {
      document: {
        data: {
          name: 'Dulles',
          state: 'VA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located near TSA PreCheck screening side on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Main Terminal - East Standard Screening Side',
        availability: [
          {
            hours: '6:00am - 9:00pm',
          },
        ],
      },
    ],
  },
  SJC: {
    uid: 'sjc',
    address: '1701 Airport Blvd San Jose, CA 95110',
    name: 'Norman Y. Miñeta San Jose International Airport - SJC',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WxZCAU' }),
    coordinates: {
      lat: 37.363949,
      lng: -121.92894,
    },
    city_and_state: 'San Jose, CA',
    city: {
      document: {
        data: {
          name: 'San Jose',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal B',
        description:
          'Located on the Departures level, on the left side of the standard security entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  SJU: {
    uid: 'sju',
    address: 'Airport Rd Carolina, PR 00979',
    name: 'Luis Muñoz Marin International Airport - SJU',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bUDCAY' }),
    coordinates: {
      lat: 18.4378,
      lng: -66.0042,
    },
    city_and_state: 'Carolina, PR',
    city: {
      document: {
        data: {
          name: 'Carolina',
          state: 'PR',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal B',
        description:
          'Located on the Departures level near Door #1, next to the elevator. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal C, Security Level',
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal C',
        description:
          'Located on the Departures level near Door #2. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  BOI: {
    uid: 'boi',
    address: '3201 W Airport Way #1000 Boise, ID 83705',
    name: 'Boise Airport - BOI',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '5:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000Wr7CAE' }),
    coordinates: {
      lat: 43.5609,
      lng: -116.2174,
    },
    city_and_state: 'Boise, ID',
    city: {
      document: {
        data: {
          name: 'Boise',
          state: 'ID',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the right side of the TSA PreCheck security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '5:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  DAL: {
    uid: 'dal',
    address: '8008 Herb Kelleher Way Dallas, TX 75235',
    name: 'Dallas Love Field - DAL',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bHJCAY' }),
    coordinates: {
      lat: 32.848152,
      lng: -96.851349,
    },
    city_and_state: 'Dallas, TX',
    city: {
      document: {
        data: {
          name: 'Dallas',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the west side of the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  ONT: {
    uid: 'ont',
    address: '2500 E Airport Drive Ontario, CA 91761',
    name: 'Ontario International Airport - ONT',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aptCAA' }),
    coordinates: {
      lat: 34.056,
      lng: -117.5981,
    },
    city_and_state: 'Ontario, CA',
    city: {
      document: {
        data: {
          name: 'Ontario',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 2',
        description:
          'Located on the ground floor main entrance across from Alaska Airlines. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 7:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal 4',
        description:
          'Located on ground floor main entrance across from Southwest Airlines. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  PSP: {
    uid: 'psp',
    address: '3400 E Tahquitz Canyon Way Palm Springs, CA 92262',
    name: 'Palm Springs International Airport - PSP',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a8LCAQ' }),
    coordinates: {
      lat: 33.8303,
      lng: -116.507,
    },
    city_and_state: 'Palm Springs, CA',
    city: {
      document: {
        data: {
          name: 'Palm Springs',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located to the right of the main entrance door. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  ORD: {
    uid: 'ord',
    address: "10000 W O'Hare Ave Chicago, IL 60666",
    name: "Chicago O'Hare International Airport - ORD",
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bQzCAI' }),
    coordinates: {
      lat: 41.9803,
      lng: -87.909,
    },
    city_and_state: 'Chicago, IL',
    city: {
      document: {
        data: {
          name: 'Chicago',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 1',
        description:
          'Located at Terminal 1 nearby the security checkpoint on the Departures Level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  MDW: {
    uid: 'mdw',
    address: '5700 S Cicero Ave Chicago, IL 60638',
    name: 'Chicago Midway International Airport - MDW',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000awLCAQ' }),
    coordinates: {
      lat: 41.7868,
      lng: -87.7522,
    },
    city_and_state: 'Chicago, IL',
    city: {
      document: {
        data: {
          name: 'Chicago',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the Mezzanine level near North security checkpoint bridge. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  BOS: {
    uid: 'bos',
    address: '1 Harborside Dr Boston, MA 02128',
    name: 'Boston Logan International Airport - BOS',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '5:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a1tCAA' }),
    coordinates: {
      lat: 42.3654,
      lng: -71.0108,
    },
    city_and_state: 'Boston, MA',
    city: {
      document: {
        data: {
          name: 'Boston',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal A, Security Level',
        description:
          'Located to the right of the security checkpoint entrance near Door A202. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal B, Security Level',
        availability: [
          {
            hours: '5:00am - 6:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal C, Security Level',
        description:
          'Located near the JetBlue check-in counter and Door C204. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '5:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  CMH: {
    uid: 'cmh',
    address: '4600 International Gateway Columbus, OH 43219',
    name: 'John Glenn Columbus International Airport - CMH',
    open: true,
    type: 'airport',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a3VCAQ' }),
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 39.9999,
      lng: -82.8872,
    },
    city_and_state: 'Columbus, OH',
    city: {
      document: {
        data: {
          name: 'Columbus',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal B',
        description:
          'Located at Checkpoint B, in the center of the landside terminal. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 7:30pm',
          },
        ],
      },
    ],
  },
  MCI: {
    uid: 'mci',
    address: '1 Kansas City Blvd Kansas City, MO 64153',
    name: 'Kansas City International Airport - MCI',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ZyfCAE' }),
    coordinates: {
      lat: 39.0997,
      lng: -94.5786,
    },
    city_and_state: 'Kansas City, MO',
    city: {
      document: {
        data: {
          name: 'Kansas City',
          state: 'MO',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located across from the Southwest Airlines ticket counter on the Departures level, near the South escalators. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  PBI: {
    uid: 'pbi',
    address: '1000 James L. Turnage Blvd West Palm Beach, FL 33415',
    name: 'Palm Beach International Airport - PBI',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bFhCAI' }),
    coordinates: {
      lat: 26.6857,
      lng: -80.0928,
    },
    city_and_state: 'West Palm Beach, FL',
    city: {
      document: {
        data: {
          name: 'West Palm Beach',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal C, Security Level',
        description:
          'Located in Terminal C on the second level across from the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  CLE: {
    uid: 'cle',
    address: '5300 Riverside Dr Cleveland, OH 44135',
    name: 'Cleveland Hopkins International Airport - CLE',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 8:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aQ5CAI' }),
    coordinates: {
      lat: 41.4993,
      lng: -81.6944,
    },
    city_and_state: 'Cleveland, OH',
    city: {
      document: {
        data: {
          name: 'Cleveland',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the Departures level between Door 3 and 4. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  RDU: {
    uid: 'rdu',
    address: '2400 John Brantley Blvd Morrisville, NC 27560',
    name: 'Raleigh-Durham International Airport - RDU',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WmHCAU' }),
    coordinates: {
      lat: 35.8801,
      lng: -78.788,
    },
    city_and_state: 'Morrisville, NC',
    city: {
      document: {
        data: {
          name: 'Morrisville',
          state: 'NC',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 2',
        description:
          'Located across from the Delta Air Lines ticketing counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  TUL: {
    uid: 'tul',
    address: '7777 Airport Dr Tulsa, OK 74115',
    name: 'Tulsa International Airport - TUL',
    open: true,
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000b2nCAA' }),
    coordinates: {
      lat: 36.1874,
      lng: -95.8931,
    },
    city_and_state: 'Tulsa, OK',
    city: {
      document: {
        data: {
          name: 'Tulsa',
          state: 'OK',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located across from the Security Checkpoint in Schaub Hall. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  BNA: {
    uid: 'bna',
    address: '1 Terminal Dr Nashville, TN 37214',
    name: 'Nashville International Airport - BNA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000at7CAA' }),
    coordinates: {
      lat: 36.1245,
      lng: -86.6781,
    },
    city_and_state: 'Nashville, TN',
    city: {
      document: {
        data: {
          name: 'Nashville',
          state: 'TN',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on North checkpoint of the security checkpoint entrance, near Delta Air Lines and United Airlines. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  CVG: {
    uid: 'cvg',
    address: '3087 Terminal Dr Hebron, KY 41048',
    name: 'Cincinnati/Northern Kentucky International Airport - CVG',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 7:30pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aujCAA' }),
    coordinates: {
      lat: 39.0514,
      lng: -84.6671,
    },
    city_and_state: 'Hebron, KY',
    city: {
      document: {
        data: {
          name: 'Hebron',
          state: 'KY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the Departures level near the security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Main Terminal, Rent-A-Car (RAC) enrollment location.',
        availability: [
          {
            hours: '6:00am - 7:30pm',
          },
        ],
      },
    ],
  },
  DFW: {
    uid: 'dfw',
    address: '2400 Aviation Dr Dallas, TX 75261',
    name: 'Dallas/Fort Worth International Airport - DFW',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    coordinates: {
      lat: 32.8448,
      lng: -96.8495,
    },
    city_and_state: 'Dallas, TX',
    city: {
      document: {
        data: {
          name: 'Dallas',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal E',
        description:
          'Located on Level 1 through Door E20 in Terminal E. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal E - E16 Checkpoint location.',
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  GSP: {
    uid: 'gsp',
    address: '2000 GSP Dr. Greer, SC 29651',
    name: 'Greenville-Spartanburg International Airport - GSP',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ZqbCAE' }),
    coordinates: {
      lat: 34.8959,
      lng: -82.2172,
    },
    city_and_state: 'Greer, SC',
    city: {
      document: {
        data: {
          name: 'Greer',
          state: 'SC',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the second floor across from the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  PIT: {
    uid: 'pit',
    address: '1000 Airport Blvd Pittsburgh, PA 15231',
    name: 'Pittsburgh International Airport - PIT',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 7:30pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aOTCAY' }),
    coordinates: {
      lat: 40.444,
      lng: -79.9605,
    },
    city_and_state: 'Pittsburgh, PA',
    city: {
      document: {
        data: {
          name: 'Pittsburgh',
          state: 'PA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located landside on the second floor next to the main security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 7:30pm',
          },
        ],
      },
    ],
  },
  OKC: {
    uid: 'okc',
    address: '7100 Terminal Dr Oklahoma City, OK 73159',
    name: 'Will Rogers World Airport - OKC',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aoHCAQ' }),
    coordinates: {
      lat: 35.4676,
      lng: -97.5164,
    },
    city_and_state: 'Oklahoma City, OK',
    city: {
      document: {
        data: {
          name: 'Oklahoma City',
          state: 'OK',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located next to the Delta Air Lines ticketing counter on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 4:00pm',
          },
        ],
      },
    ],
  },
  BUF: {
    uid: 'buf',
    address: '4200 Genesee St Buffalo, NY 14225',
    name: 'Buffalo Niagara International Airport - BUF',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '4:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a57CAA' }),
    coordinates: {
      lat: 42.9413,
      lng: -78.7303,
    },
    city_and_state: 'Buffalo, NY',
    city: {
      document: {
        data: {
          name: 'Buffalo',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the Departures level in front of the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  SAT: {
    uid: 'sat',
    address: '9800 Airport Blvd San Antonio, TX 78216',
    name: 'San Antonio International Airport - SAT',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a6jCAA' }),
    coordinates: {
      lat: 29.5268,
      lng: -98.4721,
    },
    city_and_state: 'San Antonio, TX',
    city: {
      document: {
        data: {
          name: 'San Antonio',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal A',
        description:
          'Located on the main security level near the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal B, Security Level.',
        availability: [
          {
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  OGG: {
    uid: 'ogg',
    address: '1 Keolani Pl Kahului, HI 96732',
    name: 'Kahului Airport - OGG',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 2:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bPNCAY' }),
    coordinates: {
      lat: 20.8946,
      lng: -156.4361,
    },
    city_and_state: 'Kahului, HI',
    city: {
      document: {
        data: {
          name: 'Kahului',
          state: 'HI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          "Located in the main terminal across from airlines' ticketing counters, near the security checkpoint. Look for TSA PreCheck and CLEAR signage.",
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 2:00pm',
          },
        ],
      },
    ],
  },
  HNL: {
    uid: 'hnl',
    address: '300 Rodgers Blvd Honolulu, HI 96819',
    name: 'Daniel K. Inouye International Airport - HNL',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 2:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bM9CAI' }),
    coordinates: {
      lat: 21.3099,
      lng: -157.8581,
    },
    city_and_state: 'Honolulu, HI',
    city: {
      document: {
        data: {
          name: 'Honolulu',
          state: 'HI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 1',
        description:
          'Located near the security checkpoint 1B entrance on Level 2. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 2:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal 2',
        description:
          'Located in front of checkpoint 3 security entrance on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '9:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  BDL: {
    uid: 'bdl',
    address: 'Schoephoester Rd Windsor Locks, CT 06096',
    name: 'Bradley International Airport - BDL',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '4:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000axxCAA' }),
    coordinates: {
      lat: 41.9389,
      lng: -72.686,
    },
    city_and_state: 'Windsor Locks, CT',
    city: {
      document: {
        data: {
          name: 'Windsor Locks',
          state: 'CT',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal A',
        description:
          'Located on the Departures level Door 3, across from the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '4:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0348: {
    uid: 'SP0348',
    address: '284 Hartford Ave Bellingham, MA 02019',
    name: 'Staples - Bellingham, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000SFdCAM' }),
    coordinates: {
      lat: 42.1164,
      lng: -71.4615,
    },
    city_and_state: 'Bellingham, MA',
    city: {
      document: {
        data: {
          name: 'Bellingham',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section. Enter through the front vestibule, turn left and walk all the way to the back. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1702: {
    uid: 'SP1702',
    address: '2933 Vauxhall Road, Suite 7 Vauxhall, NJ 07088',
    name: 'Staples - Millburn, NJ',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TGXCA2' }),
    coordinates: {
      lat: 40.7201,
      lng: -74.2884,
    },
    city_and_state: 'Vauxhall, NJ',
    city: {
      document: {
        data: {
          name: 'Vauxhall',
          state: 'NJ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section. Enter through the front vestibule, turn left past the Easy Tech center. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1257: {
    uid: 'SP1257',
    address: '409 Gateway Drive Brooklyn, NY 11239',
    name: 'Staples - Brooklyn - Gateway Ctr, NY',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TbVCAU' }),
    coordinates: {
      lat: 40.6521,
      lng: -73.8715,
    },
    city_and_state: 'Brooklyn, NY',
    city: {
      document: {
        data: {
          name: 'Brooklyn',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0161: {
    uid: 'SP0161',
    address: '280 State Rt 17 East Rutherford, NJ 07073',
    name: 'Staples - East Rutherford, NJ',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TZtCAM' }),
    coordinates: {
      lat: 40.8251,
      lng: -74.0953,
    },
    city_and_state: 'East Rutherford, NJ',
    city: {
      document: {
        data: {
          name: 'East Rutherford',
          state: 'NJ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1767: {
    uid: 'SP1767',
    address: '7199 S. Kingery Hwy Willowbrook, IL 60527',
    name: 'Staples - Willowbrook, IL',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000SltCAE' }),
    coordinates: {
      lat: 41.7575,
      lng: -87.9446,
    },
    city_and_state: 'Willowbrook, IL',
    city: {
      document: {
        data: {
          name: 'Willowbrook',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0033: {
    uid: 'SP0033',
    address: '701 W Route 70 Marlton, NJ 08053',
    name: 'Staples - Marlton, NJ',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000Td7CAE' }),
    coordinates: {
      lat: 39.8968,
      lng: -74.9382,
    },
    city_and_state: 'Marlton, NJ',
    city: {
      document: {
        data: {
          name: 'Marlton',
          state: 'NJ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1788: {
    uid: 'SP1788',
    address: '7000 West Forest Preserve Dr Norridge, IL 60706',
    name: 'Staples - Norridge, IL',
    type: 'staples',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TwTCAU' }),
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 41.9563,
      lng: -87.8033,
    },
    city_and_state: 'Norridge, IL',
    city: {
      document: {
        data: {
          name: 'Norridge',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1078: {
    uid: 'SP1078',
    address: '241 East 17th St Costa Mesa, CA 92627',
    name: 'Staples - Costa Mesa, CA',
    type: 'staples',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000Ty5CAE' }),
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 33.6339,
      lng: -117.9176,
    },
    city_and_state: 'Costa Mesa, CA',
    city: {
      document: {
        data: {
          name: 'Costa Mesa',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1621: {
    uid: 'SP1621',
    address: '3313 Century Center Street SW Grandville, MI 49418',
    name: 'Staples - Grandville, MI',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000SifCAE' }),
    coordinates: {
      lat: 42.8817,
      lng: -85.7446,
    },
    city_and_state: 'Grandville, MI',
    city: {
      document: {
        data: {
          name: 'Grandville',
          state: 'MI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0040: {
    uid: 'SP0040',
    address: '442 S. Oyster Bay Road Hicksville, NY 11801',
    name: 'Staples - Hicksville, NY',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000SkHCAU' }),
    coordinates: {
      lat: 40.7805,
      lng: -73.5033,
    },
    city_and_state: 'Hicksville, NY',
    city: {
      document: {
        data: {
          name: 'Hicksville',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Sunday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  HPN: {
    uid: 'HPN',
    address: '240 Airport Rd West Harrison, NY 10604',
    name: 'Westchester County Airport - HPN',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 6:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000a9xCAA' }),
    coordinates: {
      lat: 41.0685,
      lng: -73.7041,
    },
    city_and_state: 'West Harrison, NY',
    city: {
      document: {
        data: {
          name: 'West Harrison',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the ground floor near the baggage claim area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '5:00am - 1:00pm',
          },
        ],
      },
    ],
  },
  SP1429: {
    uid: 'SP1429',
    address: '10853 US Highway 285 Conifer, CO 80433',
    name: 'Staples - Conifer, CO',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TzhCAE' }),
    coordinates: {
      lat: 39.5186,
      lng: -105.3061,
    },
    city_and_state: 'Conifer, CO',
    city: {
      document: {
        data: {
          name: 'Conifer',
          state: 'CO',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1799: {
    uid: 'SP1799',
    address: '6375 Penn Ave Pittsburgh, PA 15205',
    name: 'Staples - Pittsburgh, PA - Penn Ave',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000U1JCAU' }),
    coordinates: {
      lat: 40.459,
      lng: -79.9174,
    },
    city_and_state: 'Pittsburgh, PA',
    city: {
      document: {
        data: {
          name: 'Pittsburgh',
          state: 'PA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1353: {
    uid: 'SP1353',
    address: '207 South McDowell Blvd Petaluma, CA 94954',
    name: 'Staples - Petaluma, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000U2vCAE' }),
    coordinates: {
      lat: 38.25,
      lng: -122.6248,
    },
    city_and_state: 'Petaluma, CA',
    city: {
      document: {
        data: {
          name: 'Petaluma',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0012: {
    uid: 'SP0012',
    address: '545 US Highway 46 Totowa, NJ 07512',
    name: 'Staples - Totowa, NJ',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000U4XCAU' }),
    coordinates: {
      lat: 40.8952,
      lng: -74.2392,
    },
    city_and_state: 'Totowa, NJ',
    city: {
      document: {
        data: {
          name: 'Totowa',
          state: 'NJ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0809: {
    uid: 'SP0809',
    address: '8245 East 96th St Fishers, IN 46256',
    name: 'Staples - Fishers, IN',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000U69CAE' }),
    coordinates: {
      lat: 39.9288,
      lng: -86.0176,
    },
    city_and_state: 'Fishers, IN',
    city: {
      document: {
        data: {
          name: 'Fishers',
          state: 'IN',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0025: {
    uid: 'SP0025',
    address: '2329 Street Rd Bensalem, PA 19020',
    name: 'Staples - Bensalem, PA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000U7lCAE' }),
    coordinates: {
      lat: 40.1048,
      lng: -74.9482,
    },
    city_and_state: 'Bensalem, PS',
    city: {
      document: {
        data: {
          name: 'Bensalem',
          state: 'PS',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1663: {
    uid: 'SP1663',
    address: '1371 Boston Post Rd Milford, CT 06460',
    name: 'Staples - Milford, CT',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000U9NCAU' }),
    coordinates: {
      lat: 41.2399,
      lng: -73.0342,
    },
    city_and_state: 'Milford, CT',
    city: {
      document: {
        data: {
          name: 'Milford',
          state: 'CT',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0497: {
    uid: 'SP0497',
    address: '213 North Glendale Ave Glendale, CA 91206',
    name: 'Staples - Glendale, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000UAzCAM' }),
    coordinates: {
      lat: 34.1485,
      lng: -118.2482,
    },
    city_and_state: 'Glendale, CA',
    city: {
      document: {
        data: {
          name: 'Glendale',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
          {
            days: 'Sunday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  WTC: {
    uid: 'WTC',
    address: '185 Greenwich St LL3110 New York, NY 10006',
    name: 'CLEAR World Trade Center - The Oculus',
    type: 'oculus',
    hours: '9:00am - 5:00pm',
    open: true,
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bZ3CAI' }),
    coordinates: {
      lat: 40.7099,
      lng: -74.0126,
    },
    city_and_state: 'New York, NY',
    city: {
      document: {
        data: {
          name: 'New York',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the main floor of World Trade Center - The Oculus, directly near the subway entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '8:00am - 7:00pm',
          },
          {
            days: 'Saturday - Sunday',
            hours: '10:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  SP1021: {
    uid: 'SP1021',
    address: '1675 Route 228 Cranberry Township, PA 16066',
    name: 'Staples - Cranberry Township, PA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000UCbCAM' }),
    coordinates: {
      lat: 40.6869,
      lng: -80.0788,
    },
    city_and_state: 'Cranberry Township, PA',
    city: {
      document: {
        data: {
          name: 'Cranberry Township',
          state: 'PA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  MOA: {
    uid: 'MOA',
    address: '60 E Broadway Bloomington, MN 55425',
    name: 'CLEAR Mall of America',
    type: 'mall',
    hours: '9:00am - 5:00pm',
    open: true,
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bXRCAY' }),
    coordinates: {
      lat: 44.8565,
      lng: -93.2394,
    },
    city_and_state: 'Bloomington, MN',
    city: {
      document: {
        data: {
          name: 'Bloomington',
          state: 'MN',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the main floor of Mall of America by the main escalator. Enter via the East parking ramp, turn left at the rotunda, and follow the walkway to the Southeast corner. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '11:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0093: {
    uid: 'SP0093',
    address: '6816 Katella Ave Cypress, CA 90630',
    name: 'Staples - Cypress, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TQDCA2' }),
    coordinates: {
      lat: 33.8027,
      lng: -118.0144,
    },
    city_and_state: 'Cypess, CA',
    city: {
      document: {
        data: {
          name: 'Cypess',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  SP1446: {
    uid: 'SP1446',
    address: '5150 W 120th Ave Suite 100 Westminster, CO 80020',
    name: 'Staples - Westminster - Broomfield, CO',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000UFpCAM' }),
    coordinates: {
      lat: 39.9122,
      lng: -105.0505,
    },
    city_and_state: 'Westminster - Broomfield, CO',
    city: {
      document: {
        data: {
          name: 'Westminster - Broomfield',
          state: 'CO',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1102: {
    uid: 'SP1102',
    address: '3333 Preston Road Frisco, TX 75034',
    name: 'Staples - Frisco, TX',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000TRpCAM' }),
    coordinates: {
      lat: 33.107,
      lng: -96.8134,
    },
    city_and_state: 'Frisco, TX',
    city: {
      document: {
        data: {
          name: 'Frisco',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0236: {
    uid: 'SP0236',
    address: '816 William S Canning Blvd Fall River, MA 02721',
    name: 'Staples - Fall River, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000VBtCAM' }),
    coordinates: {
      lat: 41.6714,
      lng: -71.1598,
    },
    city_and_state: 'Fall River, MA',
    city: {
      document: {
        data: {
          name: 'Fall River',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday, Wednesday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0123: {
    uid: 'SP0123',
    address: '1167 Berkshire Blvd Wyomissing, PA 19610',
    name: 'Staples - Wyomissing, PA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000VDVCA2' }),
    coordinates: {
      lat: 40.3412,
      lng: -75.978,
    },
    city_and_state: 'Wyomissing, PA',
    city: {
      document: {
        data: {
          name: 'Wyomissing',
          state: 'PA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Beginning 5/13',
          },
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP0117: {
    uid: 'SP0117',
    address: '1310 South Beach Blvd La Habra, CA 90631',
    name: 'Staples - La Habra, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WUXCA2' }),
    coordinates: {
      lat: 33.9169,
      lng: -117.968,
    },
    city_and_state: 'La Habra, CA',
    city: {
      document: {
        data: {
          name: 'La Habra',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Saturday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  SP0324: {
    uid: 'SP0324',
    address: '3003 East Michigan Ave Lansing, MI 48912',
    name: 'Staples - Lansing - East, MI',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000WW9CAM' }),
    coordinates: {
      lat: 42.7341,
      lng: -84.5093,
    },
    city_and_state: 'Lansing, MI',
    city: {
      document: {
        data: {
          name: 'Lansing',
          state: 'MI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0630: {
    uid: 'SP0630',
    address: '1210 Hammer Ave Norco, CA 92860',
    name: 'Staples - Norco, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000XQbCAM' }),
    coordinates: {
      lat: 33.9003,
      lng: -117.5645,
    },
    city_and_state: 'Norco, CA',
    city: {
      document: {
        data: {
          name: 'Norco',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  STL: {
    uid: 'STL',
    address: '10701 Lambert International Blvd St. Louis, MO 63145',
    name: 'St. Louis Lambert International Airport - STL',
    type: 'airport',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000f81CAA' }),
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 7:00pm',
    coordinates: {
      lat: 38.7424,
      lng: -90.3642,
    },
    city_and_state: 'St. Louis, MO',
    city: {
      document: {
        data: {
          name: 'St. Louis',
          state: 'MO',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 2',
        description:
          'Located inside the upper level of Terminal 2 near Door 2 and 3. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal 1, Checkpoint A',
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  SP0627: {
    uid: 'SP0627',
    address: '436 N. Main St. Doylestown, PA 18901',
    name: 'Staples - Doylestown, PA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000XVRCA2' }),
    coordinates: {
      lat: 40.32004,
      lng: -75.1308,
    },
    city_and_state: 'Doylestown, PA',
    city: {
      document: {
        data: {
          name: 'Doylestown',
          state: 'PA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
          {
            days: 'Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  SP0454: {
    uid: 'SP0454',
    address: '4450 Mitchellville Road Bowie, MD 20716',
    name: 'Staples - Bowie, MD',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000XYfCAM' }),
    coordinates: {
      lat: 38.9506,
      lng: -76.7215,
    },
    city_and_state: 'Bowie, MD',
    city: {
      document: {
        data: {
          name: 'Bowie',
          state: 'MD',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday, Wednesday, & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  SP1128: {
    uid: 'SP1128',
    address: '5140 East Southport Rd Southport, IN 20716',
    name: 'Staples - Southport, IN',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000aMrCAI' }),
    coordinates: {
      lat: 39.66704,
      lng: -86.0811,
    },
    city_and_state: 'Southport, IN',
    city: {
      document: {
        data: {
          name: 'Southport',
          state: 'IN',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  GRR: {
    uid: 'GRR',
    address: '5500 44th Street SE Grand Rapids, MI 49512',
    name: 'Gerald R. Ford International Airport - GRR',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000al3CAA' }),
    coordinates: {
      lat: 42.8853,
      lng: -85.5303,
    },
    city_and_state: 'Grand Rapids, MI',
    city: {
      document: {
        data: {
          name: 'Grand Rapids',
          state: 'MI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on Level 1 near the baggage claim area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '7:00am - 3:00pm',
          },
        ],
      },
    ],
  },
  PDX: {
    uid: 'PDX',
    address: '7000 NE Airport Way Portland, OR 97218',
    name: 'Portland International Airport - PDX',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bqnCAA' }),
    coordinates: {
      lat: 45.5889,
      lng: -122.59304,
    },
    city_and_state: 'Portland, OR',
    city: {
      document: {
        data: {
          name: 'Portland',
          state: 'OR',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal',
        description:
          'Located on the ticketing level on the North side of the Garden. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '7:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  PLA: {
    uid: 'PLA',
    address: '525 Avenida F.D. Roosevelt, San Juan, 00918, Puerto Rico',
    name: 'CLEAR Plaza Las Americas',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000c0TCAQ' }),
    coordinates: {
      lat: 18.4188,
      lng: -66.0733,
    },
    city_and_state: 'San Juan, PR',
    city: {
      document: {
        data: {
          name: 'San Juan',
          state: 'PR',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on level 1 of Plaza Las Americas, across from the Lacoste store. Enter via the entrance near the Genesis store, proceed straight ahead, and take a right before the escalator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 7:00pm',
          },
        ],
      },
    ],
  },
  CBS: {
    uid: 'CBS',
    address: '100 Cambridgeside Pl Cambridge, MA 02141',
    name: 'CLEAR CambridgeSide',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000bxFCAQ' }),
    coordinates: {
      lat: 42.3678,
      lng: -71.0757,
    },
    city_and_state: 'Cambridge, MA',
    city: {
      document: {
        data: {
          name: 'Cambridge',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located near the CambridgeSide Place entrance. Enter via the CambridgeSide Place entrance (near Cheesecake Factory) and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '11:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0726: {
    uid: 'SP0726',
    address: '2415 West Kettleman Lane Lodi, CA 95242',
    name: 'Staples - Lodi, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000XTpCAM' }),
    coordinates: {
      lat: 38.11706,
      lng: -121.3042,
    },
    city_and_state: 'Lodi, CA',
    city: {
      document: {
        data: {
          name: 'Lodi',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 1:00pm, 1:30pm - 6:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  SP1108: {
    uid: 'SP1108',
    address: '898 West Main Rd Middletown, RI 02842',
    name: 'Staples - Middletown, RI',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000Xs1CAE' }),
    coordinates: {
      lat: 41.5271,
      lng: -71.2996,
    },
    city_and_state: 'Middletown, RI',
    city: {
      document: {
        data: {
          name: 'Middletown',
          state: 'RI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1825: {
    uid: 'SP1825',
    address: '2100 Nesconset Stony Brook, NY 11790',
    name: 'Staples - Stony Brook, NY',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000cJpCAI' }),
    coordinates: {
      lat: 40.8707,
      lng: -73.1301,
    },
    city_and_state: 'Stony Brook, NY',
    city: {
      document: {
        data: {
          name: 'Stony Brook',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Thursday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SGM: {
    uid: 'SGM',
    address: '12801 W Sunrise Blvd Sunrise, FL 33323',
    name: 'CLEAR Sawgrass Mills',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000c5JCAQ' }),
    coordinates: {
      lat: 26.1514,
      lng: -80.32104,
    },
    city_and_state: 'Sunrise, FL',
    city: {
      document: {
        data: {
          name: 'Sunrise',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the main floor between the Perry Ellis and Burlington Coat Factory stores. Enter via the Oasis entrance and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  PHX: {
    uid: 'phx',
    address: '400 Sky Hbr Blvd Phoenix, AZ 85034',
    name: 'Phoenix Sky Harbor International Airport - PHX',
    open: true,
    type: 'airport',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000dz3CAA' }),
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 33.4354,
      lng: -112.0079,
    },
    city_and_state: 'Phoenix, AZ',
    city: {
      document: {
        data: {
          name: 'Phoenix',
          state: 'AZ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal 3, Level 2',
        description:
          'Located on the second floor at the base of the escalators, near the TSA PreCheck screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 7:00pm',
          },
        ],
      },
      {
        id: 2,
        name: 'Terminal 4, Checkpoint B',
        description:
          'Located on the left of the security entrance of Checkpoint B, near the standard screening side. Look for TSA PreCheck and CLEAR signage.',
        accessibilityMessage:
          'Accessible pod is available at Terminal 3, Level 2.',
        availability: [
          {
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  TFM: {
    uid: 'TFM',
    address: '8001 S Orange Blossom Trl Orlando, FL 32809',
    name: 'CLEAR The Florida Mall',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000c6vCAA' }),
    coordinates: {
      lat: 28.446003,
      lng: -81.3955,
    },
    city_and_state: 'Orlando, FL',
    city: {
      document: {
        data: {
          name: 'Orlando',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          "Located on the main floor across from the Tesla store. Enter via the South entrance near Macy's. Proceed straight ahead towards guest services and turn left. Look for TSA PreCheck and CLEAR signage.",
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '11:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  TWM: {
    uid: 'TWM',
    address: '1201 Lake Woodlands Dr Suite 700 The Woodlands, TX 77380',
    name: 'CLEAR The Woodlands',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000cZxCAI' }),
    coordinates: {
      lat: 30.1646,
      lng: -95.4537,
    },
    city_and_state: 'The Woodlands, TX',
    city: {
      document: {
        data: {
          name: 'The Woodlands',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          "Located on the main floor of The Woodlands Mall. Enter via the west entrance near Macy's and head straight down the walkway. Look for TSA PreCheck and CLEAR signage.",
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  HGM: {
    uid: 'HGM',
    address: '5085 Westheimer Rd Houston, TX 77056',
    name: 'CLEAR Houston Galleria',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    open: true,
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000c8XCAQ' }),
    coordinates: {
      lat: 29.7393,
      lng: -95.46505,
    },
    city_and_state: 'Houston, TX',
    city: {
      document: {
        data: {
          name: 'Houston',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on Level 1 by the escalator, between the Express and Gap stores of the Galleria Mall. Entrance on West Alabama street, near the Museum of Illusions. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1390: {
    uid: 'SP1390',
    address: '701 West Redondo Beach Blvd Gardena, CA 90247',
    name: 'Staples - Gardena, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000d9RCAQ' }),
    coordinates: {
      lat: 33.8926,
      lng: -118.2876,
    },
    city_and_state: 'Gardena, CA',
    city: {
      document: {
        data: {
          name: 'Gardena',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1903: {
    uid: 'SP1903',
    address: '19335 Gulf Freeway Webster, TX 77598',
    name: 'Staples - Webster, TX',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eK1CAI' }),
    coordinates: {
      lat: 29.54507,
      lng: -95.1454,
    },
    city_and_state: 'Webster, TX',
    city: {
      document: {
        data: {
          name: 'Webster',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  LSM: {
    uid: 'LSM',
    address: '3393 Peachtree St Atlanta, GA 30326',
    name: 'CLEAR Lenox Square',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    hours: '6:00am - 7:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000cjdCAA' }),
    coordinates: {
      lat: 33.8145,
      lng: -84.3916,
    },
    city_and_state: 'Atlanta, FL',
    city: {
      document: {
        data: {
          name: 'Atlanta',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the 1st floor across from the UGG and Adidas stores. Enter via the main entrance and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '11:00am - 2:00pm, 2:30pm - 4:30pm, 5:00pm - 7:00pm',
          },
        ],
      },
    ],
  },
  BWI: {
    uid: 'BWI',
    address: '7050 Friendship Rd Baltimore, MD 21240',
    name: 'Baltimore/Washington International Thurgood Marshall Airport - BWI',
    open: true,
    type: 'airport',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eBxCAI' }),
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 39.1794,
      lng: -76.6685,
    },
    city_and_state: 'Baltimore, MD',
    city: {
      document: {
        data: {
          name: 'Baltimore',
          state: 'MD',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Main Terminal, Checkpoint B',
        description:
          'Located on the security level to the right of Checkpoint B, next to the Skywalk B near door 6. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  SFT: {
    uid: 'SFT',
    address: '425 Mission St San Francisco, CA 94105',
    name: 'CLEAR Salesforce Transit Center',
    type: 'flagship',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000crhCAA' }),
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 37.7902,
      lng: -122.3968,
    },
    city_and_state: 'San Francisco, CA',
    city: {
      document: {
        data: {
          name: 'San Francisco',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the ground level of the Salesforce Transit Center. Enter via the Mission and 1st street entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Thursday',
            hours: '8:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  PTC: {
    uid: 'PTC',
    address: '225/229 Peachtree Center Ave NE Atlanta, GA 30303',
    name: 'CLEAR Peachtree Center',
    type: 'flagship',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000clFCAQ' }),
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 33.7604,
      lng: -84.38802,
    },
    city_and_state: 'Atlanta, GA',
    city: {
      document: {
        data: {
          name: 'Atlanta',
          state: 'GA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the ground level of the Hub in the Peachtree Center. Head towards the food court opposite of the information desk. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '9:00am - 1:00pm',
          },
        ],
      },
    ],
  },
  SP0815: {
    uid: 'SP0815',
    address: '4014 Medina Road Akron, OH 44333',
    name: 'Staples - Akron, OH',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fETCAY' }),
    coordinates: {
      lat: 41.1358,
      lng: -81.6436,
    },
    city_and_state: 'Akron, OH',
    city: {
      document: {
        data: {
          name: 'Akron',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0855: {
    uid: 'SP0855',
    address: '12421 Pearl Road Strongsville, OH 44136',
    name: 'Staples - Strongsville, OH',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fG5CAI' }),
    coordinates: {
      lat: 41.3228,
      lng: -81.8352,
    },
    city_and_state: 'Strongsville, OH',
    city: {
      document: {
        data: {
          name: 'Strongsville',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0142: {
    uid: 'SP0142',
    address: '80 W. Sunrise Hwy Valley Stream, NY 11581',
    name: 'Staples - Valley Stream, NY',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eThCAI' }),
    coordinates: {
      lat: 40.66007,
      lng: -73.70402,
    },
    city_and_state: 'Valley Stream, NY',
    city: {
      document: {
        data: {
          name: 'Valley Stream',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1539: {
    uid: 'SP1539',
    address: '100 Powell Place Nashville, TN 37204',
    name: 'Staples - Nashville, TN',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eVJCAY' }),
    coordinates: {
      lat: 36.1056,
      lng: -86.7656,
    },
    city_and_state: 'Nashville, TN',
    city: {
      document: {
        data: {
          name: 'Nashville',
          state: 'TN',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  SRQ: {
    uid: 'SRQ',
    address: '6000 Airport Cir Sarasota, FL 34243',
    name: 'Sarasota Bradenton International Airport - SRQ',
    type: 'airport',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000hplCAA' }),
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 27.3875,
      lng: -82.5534,
    },
    city_and_state: 'Sarasota, FL',
    city: {
      document: {
        data: {
          name: 'Sarasota',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        name: 'Terminal B, Level 2',
        description:
          'Located on Level 2 near the entrance to the arrivals area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: 'Closed 3/25',
        availability: [
          {
            days: 'Monday',
            hours: '10:00am - 6:00pm',
          },
          {
            days: 'Tuesday - Sunday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  MYH: {
    uid: 'MYH',
    address: '350 W 33rd St New York, NY 10001',
    name: 'CLEAR Moynihan Train Hall',
    type: 'flagship',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000coTCAQ' }),
    parking: '',
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 40.7519,
      lng: -73.9955,
    },
    city_and_state: 'New York, NY',
    city: {
      document: {
        data: {
          name: 'New York',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the ground level of Moynihan Train Hall by Track 5 and 6, in front of the Amtrak Metropolitan Lounge. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '8:00am - 6:00pm',
          },
          {
            days: 'Saturday - Sunday',
            hours: '10:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  SLG: {
    uid: 'SLG',
    address: '1155 St Louis Galleria Street St. Louis, MO 63117',
    name: 'CLEAR Saint Louis Galleria',
    type: 'flagship',
    parking: '',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000cdBCAQ' }),
    hours: '4:00am - 7:30pm',
    coordinates: {
      lat: 38.6363,
      lng: -90.3469,
    },
    city_and_state: 'St. Louis, MO',
    city: {
      document: {
        data: {
          name: 'St. Louis',
          state: 'MO',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the main floor behind the escalator near the Garden Court area. Enter via East entrance near Nordstrom and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0085: {
    uid: 'SP0085',
    address: '1340 Reisterstown Rd #1354 Pikesville, MD 21208',
    name: 'Staples - Pikesville, MD',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eWvCAI' }),
    coordinates: {
      lat: 39.3761,
      lng: -76.7246,
    },
    city_and_state: 'Pikesville, MD',
    city: {
      document: {
        data: {
          name: 'Pikesville',
          state: 'MD',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0154: {
    uid: 'SP0154',
    address: '425 Iyannough Rd Hyannis, MA 02601',
    name: 'Staples - Hyannis, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eYXCAY' }),
    coordinates: {
      lat: 41.6629,
      lng: -70.2835,
    },
    city_and_state: 'Hyannis, MA',
    city: {
      document: {
        data: {
          name: 'Hyannis',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0459: {
    uid: 'SP0459',
    address: '8795 SW Tualatin Sherwood Rd Tualatin, OR 97062',
    name: 'Staples - Tualatin, OR',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ea9CAA' }),
    coordinates: {
      lat: 45.3821,
      lng: -122.7678,
    },
    city_and_state: 'Tualatin, OR',
    city: {
      document: {
        data: {
          name: 'Tualatin',
          state: 'OR',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Wednesday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Monday & Tuesday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  SP1471: {
    uid: 'SP1471',
    address: '6960 North 5th St N Las Vegas, NV 89084',
    name: 'Staples - N Las Vegas, NV',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eblCAA' }),
    coordinates: {
      lat: 36.28705,
      lng: -115.1328,
    },
    city_and_state: 'N Las Vegas, NV',
    city: {
      document: {
        data: {
          name: 'N Las Vegas',
          state: 'NV',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Thursday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP1634: {
    uid: 'SP1634',
    address: '1551 Algonquin Rd Rolling Meadows, IL 60008',
    name: 'Staples - Rolling Meadows, IL',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000edNCAQ' }),
    coordinates: {
      lat: 42.0305,
      lng: -87.94903,
    },
    city_and_state: 'Rolling Meadows, IL',
    city: {
      document: {
        data: {
          name: 'Rolling Meadows',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0738: {
    uid: 'SP0738',
    address: '3631 Truxel Road Natomas, CA 95834',
    name: 'Staples - Natomas, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eezCAA' }),
    coordinates: {
      lat: 38.6338,
      lng: -121.5058,
    },
    city_and_state: 'Natomas, CA',
    city: {
      document: {
        data: {
          name: 'Natomas',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Beginning 5/10',
          },
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP0360: {
    uid: 'SP0360',
    address: '1129 West 14 Mile Rd Clawson, MI 48017',
    name: 'Staples - Clawson, MI',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000hUnCAI' }),
    coordinates: {
      lat: 42.5319,
      lng: -83.1619,
    },
    city_and_state: 'Clawson, MI',
    city: {
      document: {
        data: {
          name: 'Clawson',
          state: 'MI',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10 am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0674: {
    uid: 'SP0674',
    address: '6330 Sunrise Blvd Citrus Heights, CA 95610',
    name: 'Staples - Citrus Heights, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000dCfCAI' }),
    coordinates: {
      lat: 38.6818,
      lng: -121.2708,
    },
    city_and_state: 'Citrus Heights, CA',
    city: {
      document: {
        data: {
          name: 'Citrus Heights',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Wednesday',
            hours: '9:10am - 10:20am, 10:40am - 12:00pm, 12:40pm - 3:00pm',
          },
        ],
      },
    ],
  },
  WLC: {
    uid: 'WLC',
    address: '400 Pine St Seattle, WA 98101',
    name: 'CLEAR Westlake Center',
    type: 'flagship',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000cA9CAI' }),
    coordinates: {
      lat: 47.6119,
      lng: -122.3376,
    },
    city_and_state: 'Seattle, WA',
    city: {
      document: {
        data: {
          name: 'Seattle',
          state: 'WA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located on the main floor behind the northeast escalator. Enter the mall through the Fifth Avenue entrance and follow the walkway to the escalator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        availability: [
          {
            days: 'Monday - Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 4:00pm, 4:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  SP1715: {
    uid: 'SP1715',
    address: '165 Middlesex Ave Somerville, MA 02145',
    name: 'Staples - Somerville, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000gSHCAY' }),
    coordinates: {
      lat: 42.3946,
      lng: -71.0827,
    },
    city_and_state: 'Somerville, MA',
    city: {
      document: {
        data: {
          name: 'Somerville',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1555: {
    uid: 'SP1555',
    address: '73 Turnpike St North Andover, MA 01845',
    name: 'Staples - North Andover, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000gTtCAI' }),
    coordinates: {
      lat: 42.6772,
      lng: -71.1323,
    },
    city_and_state: 'North Andover, MA',
    city: {
      document: {
        data: {
          name: 'North Andover',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP1265: {
    uid: 'SP1265',
    address: '2150 West 117th St Lakewood, OH 44111',
    name: 'Staples - Lakewood, OH',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000hwDCAQ' }),
    coordinates: {
      lat: 41.4762,
      lng: -81.7688,
    },
    city_and_state: 'Lakewood, OH',
    city: {
      document: {
        data: {
          name: 'Lakewood',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday & Thursday - Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Sunday',
            hours: '11:10am - 1:30pm, 2:00pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP1657: {
    uid: 'SP1657',
    address: '9631 S. Cicero Ave Oak Lawn, IL 60453',
    name: 'Staples - Oak Lawn, IL',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000iVhCAI' }),
    coordinates: {
      lat: 41.7175,
      lng: -87.7393,
    },
    city_and_state: 'Oak Lawn, IL',
    city: {
      document: {
        data: {
          name: 'Oak Lawn',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP0036: {
    uid: 'SP0036',
    address: '800 Lexington St Waltham, MA 02452',
    name: 'Staples - Waltham, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eofCAA' }),
    coordinates: {
      lat: 42.4025,
      lng: -71.2345,
    },
    city_and_state: 'Waltham, MA',
    city: {
      document: {
        data: {
          name: 'Waltham',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0059: {
    uid: 'SP0059',
    address: '571 Boston Turnpike Shrewsbury, MA 01545',
    name: 'Staples - Shrewsbury, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000eqHCAQ' }),
    coordinates: {
      lat: 42.2781,
      lng: -71.7132,
    },
    city_and_state: 'Shrewsbury, MA',
    city: {
      document: {
        data: {
          name: 'Shrewsbury',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0827: {
    uid: 'SP0827',
    address: '4203 Union Deposit Rd Harrisburg, PA 17111',
    name: 'Staples - Harrisburg, PA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ertCAA' }),
    coordinates: {
      lat: 40.2784,
      lng: -76.8158,
    },
    city_and_state: 'Harrisburg, PA',
    city: {
      document: {
        data: {
          name: 'Harrisburg',
          state: 'PA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1491: {
    uid: 'SP1491',
    address: '675 Green Valley Parkway Henderson (Green Valley), NV 89052',
    name: 'Staples - Henderson (Green Valley), NV',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fSzCAI' }),
    coordinates: {
      lat: 36.0035,
      lng: -115.0853,
    },
    city_and_state: 'Henderson (Green Valley), NV',
    city: {
      document: {
        data: {
          name: 'Henderson (Green Valley)',
          state: 'NV',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1611: {
    uid: 'SP1611',
    address: '111 North Wabash Ave Chicago, IL 60602',
    name: 'Staples - Chicago, IL',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fUbCAI' }),
    coordinates: {
      lat: 41.8834,
      lng: -87.6256,
    },
    city_and_state: 'Chicago, IL',
    city: {
      document: {
        data: {
          name: 'Chicago',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          {
            days: 'Saturday',
            hours: '10:10am - 1:30pm, 2:00pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP5308: {
    uid: 'SP5308',
    address: '800 3rd Ave FRNT A New York, NY 10022',
    name: 'Staples - New York, NY',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fWDCAY' }),
    coordinates: {
      lat: 40.7556,
      lng: -73.9715,
    },
    city_and_state: 'New York, NY',
    city: {
      document: {
        data: {
          name: 'New York',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday  - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1243: {
    uid: 'SP1243',
    address: '12389 Georgia Ave Wheaton, MD 20906',
    name: 'Staples - Wheaton, MD',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000jy1CAA' }),
    coordinates: {
      lat: 39.06104,
      lng: -77.0502,
    },
    city_and_state: 'Wheaton, MD',
    city: {
      document: {
        data: {
          name: 'Wheaton',
          state: 'MD',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0387: {
    uid: 'SP0387',
    address: '2460 17th Avenue Santa Cruz, CA 95062',
    name: 'Staples - Santa Cruz, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000ho9CAA' }),
    coordinates: {
      lat: 36.98506,
      lng: -121.9811,
    },
    city_and_state: 'Santa Cruz, CA',
    city: {
      document: {
        data: {
          name: 'Santa Cruz',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1386: {
    uid: 'SP1386',
    address: '12070 Lakewood Blvd Downey, CA 90242',
    name: 'Staples - Downey, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000isHCAQ' }),
    coordinates: {
      lat: 33.9261,
      lng: -118.1264,
    },
    city_and_state: 'Downey, CA',
    city: {
      document: {
        data: {
          name: 'Downey',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  SP1419: {
    uid: 'SP1419',
    address: '1755 North Pebblecreek Parkway Goodyear, AZ 85395',
    name: 'Staples - Goodyear, AZ',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fXpCAI' }),
    coordinates: {
      lat: 33.4664,
      lng: -112.3878,
    },
    city_and_state: 'Goodyear, AZ',
    city: {
      document: {
        data: {
          name: 'Goodyear',
          state: 'AZ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday, Wednesday - Friday',
            hours: '9:10am - 12:00pm, 12:30pm - 2:00pm',
          },
        ],
      },
    ],
  },
  SP0426: {
    uid: 'SP0426',
    address: '991 Providence Hwy Norwood, MA 02062',
    name: 'Staples - Norwood, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fZRCAY' }),
    coordinates: {
      lat: 42.1778,
      lng: -71.1923,
    },
    city_and_state: 'Norwood, MA',
    city: {
      document: {
        data: {
          name: 'Norwood',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday, Wednesday, & Thursday',
            hours: '9:10am - 12:00pm, 12:30pm - 2:00pm',
          },
        ],
      },
    ],
  },
  SP0913: {
    uid: 'SP0913',
    address: '4029 Pearl Rd Medina, OH 44256',
    name: 'Staples - Medina, OH',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fb3CAA' }),
    coordinates: {
      lat: 41.1649,
      lng: -81.8619,
    },
    city_and_state: 'Medina, OH',
    city: {
      document: {
        data: {
          name: 'Medina',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1615: {
    uid: 'SP1615',
    address: '992 Brook Forest Avenue Shorewood, IL 60404',
    name: 'Staples - Shorewood, IL',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fcfCAA' }),
    coordinates: {
      lat: 41.53909,
      lng: -88.1992,
    },
    city_and_state: 'Shorewood, IL',
    city: {
      document: {
        data: {
          name: 'Shorewood',
          state: 'IL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1427: {
    uid: 'SP1427',
    address: '11341 National Blvd Los Angeles, CA 90064',
    name: 'Staples - Los Angeles, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000feHCAQ' }),
    coordinates: {
      lat: 34.0262,
      lng: -118.4328,
    },
    city_and_state: 'Los Angeles, CA',
    city: {
      document: {
        data: {
          name: 'Los Angeles',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0135: {
    uid: 'SP0135',
    address: '72-811 Highway 111 Palm Desert, CA 92260',
    name: 'Staples - Palm Desert, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fftCAA' }),
    coordinates: {
      lat: 33.7299,
      lng: -116.4039,
    },
    city_and_state: 'Palm Desert, CA',
    city: {
      document: {
        data: {
          name: 'Palm Desert',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0094: {
    uid: 'SP0094',
    address: '300 S. Mountain Ave Upland, CA 91786',
    name: 'Staples - Upland, CA',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000vkfCAA' }),
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 34.0909,
      lng: -117.67005,
    },
    city_and_state: 'Upland, CA',
    city: {
      document: {
        data: {
          name: 'Upland',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  SP0165: {
    uid: 'SP0165',
    address: '3515 Atlantic Ave Long Beach, CA 90807',
    name: 'Staples - Long Beach, CA',
    type: 'staples',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000vmHCAQ' }),
    parking: 'Parking is available in front of the retail building.',
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 33.8206,
      lng: -118.1854,
    },
    city_and_state: 'Long Beach, CA',
    city: {
      document: {
        data: {
          name: 'Long Beach',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  SP0882: {
    uid: 'SP0882',
    address: '41334 North Hwy 19 N Tarpon Springs, FL 34689',
    name: 'Staples - Tarpon Springs, FL',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fhVCAQ' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 28.1471,
      lng: -82.7432,
    },
    city_and_state: 'Tarpon Springs, FL',
    city: {
      document: {
        data: {
          name: 'Tarpon Springs',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1179: {
    uid: 'SP1179',
    address: '2112 SW H.K. Dodgen Loop Suite 183 Temple, TX 76502',
    name: 'Staples - Temple, TX',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fj7CAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 31.0786,
      lng: -97.3784,
    },
    city_and_state: 'Temple, TX',
    city: {
      document: {
        data: {
          name: 'Temple',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0051: {
    uid: 'SP0051',
    address: '444 Broadway (Route 1) Saugus, MA 01906',
    name: 'Staples - Saugus, MA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fkjCAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 42.50203,
      lng: -71.0147,
    },
    city_and_state: 'Saugus, MA',
    city: {
      document: {
        data: {
          name: 'Saugus',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0207: {
    uid: 'SP0207',
    address: '9091 Snowden River Pkwy Columbia, MD 21046',
    name: 'Staples - Columbia, MD',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fmLCAQ' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 39.1816,
      lng: -76.8218,
    },
    city_and_state: 'Columbia, MD',
    city: {
      document: {
        data: {
          name: 'Columbia',
          state: 'MD',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0852: {
    uid: 'SP0852',
    address: '5500 Milan Road Sandusky, OH 44870',
    name: 'Staples - Sandusky, OH',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fnxCAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 41.4041,
      lng: -82.65609,
    },
    city_and_state: 'Sandusky, OH',
    city: {
      document: {
        data: {
          name: 'Sandusky',
          state: 'OH',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1574: {
    uid: 'SP1574',
    address: '500 Eighth Avenue Front 3 New York, NY 10018',
    name: 'Staples - New York, NY',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000frBCAQ' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 40.7529,
      lng: -73.9924,
    },
    city_and_state: 'New York, NY',
    city: {
      document: {
        data: {
          name: 'New York',
          state: 'NY',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0707: {
    uid: 'SP0707',
    address: '7000 Hadley Rd South Plainfield, NJ 07080',
    name: 'Staples - South Plainfield, NJ',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000001JGjCAM' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 40.5543,
      lng: -74.43203,
    },
    city_and_state: 'South Plainfield, NJ',
    city: {
      document: {
        data: {
          name: 'South Plainfield',
          state: 'NJ',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0616: {
    uid: 'SP0616',
    address: '3660 Colorado Blvd Pasadena, CA 91107',
    name: 'Staples - Pasadena, CA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    ...(!isUAT && { serviceTerritoryId: '0Hhcr0000001JILCA2' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 34.1456,
      lng: -118.0745,
    },
    city_and_state: 'Pasadena, CA',
    city: {
      document: {
        data: {
          name: 'Pasadena',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0229: {
    uid: 'SP0229',
    address: '13013 Seminole Blvd Largo, FL 33778',
    name: 'Staples - Largo, FL - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fsnCAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 27.8921,
      lng: -82.7864,
    },
    city_and_state: 'Largo, FL',
    city: {
      document: {
        data: {
          name: 'Largo',
          state: 'FL',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Monday, Tuesday, Thursday, and Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP1187: {
    uid: 'SP1187',
    address: '1660 S. University Drive Ft. Worth, TX 76107',
    name: 'Staples - Ft. Worth, TX - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fuPCAQ' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 32.72702,
      lng: -97.3619,
    },
    city_and_state: 'Ft. Worth, TX',
    city: {
      document: {
        data: {
          name: 'Ft. Worth',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          ...stapleHours,
          { days: 'Beginning 5/6' },
          {
            days: 'Monday - Wednesday',
            hours: '8:10am - 12:00pm, 12:30pm - 7:00pm',
          },
          {
            days: 'Thursday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP0063: {
    uid: 'SP0063',
    address: '1 Washington Street Boston, MA 02108',
    name: 'Staples - Boston, MA - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000fw1CAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 42.3592,
      lng: -71.0579,
    },
    city_and_state: 'Boston, MA',
    city: {
      document: {
        data: {
          name: 'Boston',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0186: {
    uid: 'SP0186',
    address: '131 Samoset Street (Rt 44) Plymouth, MA 02360',
    name: 'Staples - Plymouth, MA - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000g0rCAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 41.9601,
      lng: -70.6702,
    },
    city_and_state: 'Plymouth, MA',
    city: {
      document: {
        data: {
          name: 'Plymouth',
          state: 'MA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0632: {
    uid: 'SP0632',
    address: '971 S University Dr Provo, UT 84601',
    name: 'Staples - Provo, UT - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000g2TCAQ' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 40.2208,
      lng: -111.6575,
    },
    city_and_state: 'Provo, UT',
    city: {
      document: {
        data: {
          name: 'Provo',
          state: 'UT',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [
          {
            days: 'Tuesday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  SP1085: {
    uid: 'SP1085',
    address: '812 West McDermott Dr Allen, TX 75013',
    name: 'Staples - Allen, TX - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000g45CAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 33.1038,
      lng: -96.6812,
    },
    city_and_state: 'Allen, TX',
    city: {
      document: {
        data: {
          name: 'Allen',
          state: 'TX',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP1299: {
    uid: 'SP1299',
    address: '39116 Fremont Hub Fremont, CA 94538',
    name: 'Staples - Fremont, CA - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000g5hCAA' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 37.5465,
      lng: -121.9873,
    },
    city_and_state: 'Fremont, CA',
    city: {
      document: {
        data: {
          name: 'Fremont',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
  SP0336: {
    uid: 'SP0336',
    address: '2052 Bundy Drive West Los Angeles, CA 90025',
    name: 'Staples - West Los Angeles, CA - Planned Opening Apr 28th',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    // ...(!isUAT && { serviceTerritoryId: '0Hhcr0000000g7JCAQ' }),
    hours: '9:00am - 5:00pm',
    coordinates: {
      lat: 34.03306,
      lng: -118.4539,
    },
    city_and_state: 'West Los Angeles, CA',
    city: {
      document: {
        data: {
          name: 'West Los Angeles',
          state: 'CA',
        },
      },
    },
    lanes: [
      {
        id: 1,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        holidayMessage: staplesHolidayMessage,
        availability: [...stapleHours],
      },
    ],
  },
}
